<template>
	<div class="tci-request position_center md-layout-item" style="max-width:920px;">
		<br/>

		<div v-if="isAccepted" class="centered-title">
			<i class="fa fa-check fa valid_color" aria-hidden="true" style="font-size: 30px"/>
			<h4 class="font_lg font_bold margin_top margin-left text_justify" style="margin-left: 15px;">
				{{ $t("company.tciActivation.activatedTCI") }}
			</h4>
		</div>
		<div v-if="isRejected" class="centered-title">
			<i class="fa fa-times fa invalid_color" aria-hidden="true" style="font-size: 30px"/>
			<h4 class="font_lg font_bold margin_top margin-left text_justify" style="margin-left: 15px; margin-top: 5px">
				{{ $t("company.tciActivation.rejected") }}
			</h4>
		</div>
		<h4 class="font_lg font_bold margin_top" v-if="isNone">
			{{ $t("company.tciActivation.activateTCI") }}
		</h4>
		<div v-if="isRequested" class="centered-title">
			<i class="fa fa-check fa valid_color" aria-hidden="true" style="font-size: 30px"/>
			<h4 class="font_lg font_bold margin_top margin-left text_justify" style="margin-left: 15px;">
				<span v-html="$t('company.tciActivation.requested')"/>
			</h4>
		</div>

		<p class="text_justify">
			{{ $t("company.tciActivation.intro") }}
		</p>

		<p class="text_justify">
			{{ $t("company.tciActivation.steps") }}
		</p>

		<div style="margin: 25px">
			<div style="display: flex; align-items: center">
				1.
				<p class="text_justify" style="margin-left: 20px">
					{{ $t("company.tciActivation.firstStep") }}
				</p>
			</div>
			<div style="display: flex; align-items: center">
				2.
				<p class="text_justify" style="margin-left: 20px">
					{{ $t("company.tciActivation.secondStep") }}
				</p>
			</div>
			<div style="display: flex; align-items: center">
				3.
				<p class="text_justify" style="margin-left: 20px">
					{{ $t("company.tciActivation.thirdStep") }}
				</p>
			</div>
		</div>
		<br/>
		<p class="text_justify">
			{{ $t("company.tciActivation.disclaimer") }}
		</p>

		<div v-if="isNone">
			<div class="checkbox tci-checkbox">
				<md-checkbox v-model="form.agreedToTerms"/>
				<span v-html="$t('company.tciActivation.termsAndConditions', {url: termsAndConditions})"/>
			</div>

			<md-button class="opacity_5" :disabled="!isFormValid" :class="{ 'md-primary': isFormValid }" v-on:click="submit">
				{{ $t("common.button.accept") }}
			</md-button>
		</div>

	</div>
</template>
<script>
import {companyProfileApi} from "@/common/api/companyProfileApi";
import {enumDef} from "@/common/enumDefs";

export default {
	data() {
		return {
			defaultForm: {
				agreedToTerms: false
			},
			form : {...this.defaultForm},
			status: null
		}
	},
	methods: {
		submit() {
			companyProfileApi.operation.acceptTciTOS()
				.then(() => {
					this.toastSuccess(this.$t("company.tciActivation.submit.success"));
					this.loadTciConfirmationStage();
				}).catch(this.toast);
		},
		loadTciConfirmationStage() {
			companyProfileApi.inspection.getCompanyInsurancePolicyHolderStatus()
				.then(res => {
					this.status = res;
				}).catch(this.toast);
		}
	},
	computed: {
		isFormValid() {
			return this.form.agreedToTerms;
		},
		termsAndConditions() {
			return "/vue/pdf/creditinsurance/TCI_terms_and_conditions_en_de.pdf";
		},
		isAccepted() {
			return this.status === enumDef.creditInsurancePolicyHolderStatus.ACCEPTED;
		},
		isRejected() {
			return this.status === enumDef.creditInsurancePolicyHolderStatus.REJECTED;
		},
		isNone() {
			return this.status === enumDef.creditInsurancePolicyHolderStatus.NONE;
		},
		isRequested() {
			return this.status === enumDef.creditInsurancePolicyHolderStatus.REQUESTED;
		}
	},
	beforeMount() {
		this.form = {...this.defaultForm}
		this.loadTciConfirmationStage();
	},

}
</script>

<style lang="scss">
	.tci-request {
		.sub-title {
			margin-top: 28px;
		}
		.tip_list {
			list-style: circle;
			padding: 0 0 0 16px;
			li {
				margin: 0 0 8px 0;
			}
			i {
				padding-right: 12px;
			}
		}
	}
	.centered-title {
		display: flex;
		align-items: center
	}
	.tci-checkbox {
		display: flex;
		align-items: center;
		justify-content: center
	}
</style>